/**
 * Checking for missing brackets and checking that all are correctly balanced and nested
 * @param textValue
 */
export const checkParenthesesInString = (textValue: string) => {
    let localString = "";

    if (typeof textValue === "string") {
        let stringValue = textValue.replace(/[^()]/g, "");

        while (localString !== stringValue) {
            localString = stringValue;
            stringValue = stringValue.replace(/\(\)/g, "");
        }
        return !stringValue;
    }
    return !textValue;
};
